export default __webpack_public_path__ + "static/media/523.b9d52bb7.png";